var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBtmRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 509 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.348 108.123C441.706 89.1199 526.096 98.5419 589.803 148.058C655.905 199.435 695.618 280.095 692.281 363.785C689.025 445.474 634.807 510.414 573.219 564.07C504.733 623.736 427.698 686.843 338.031 672.414C241.478 656.877 157.101 584.53 125.193 491.976C95.9671 407.202 143.383 321.015 190.631 244.862C231.377 179.188 288.287 126.326 363.348 108.123Z",
    fill: "#BFBEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.732 189.906C315.628 188.133 312.739 187.617 310.151 188.552L293.167 194.691C290.579 195.627 288.687 197.871 288.204 200.579L285.028 218.358C284.544 221.066 285.542 223.827 287.646 225.6L301.454 237.24C303.558 239.013 306.448 239.529 309.035 238.594L326.02 232.455C328.607 231.519 330.499 229.275 330.983 226.567L334.158 208.788C334.642 206.08 333.644 203.319 331.541 201.546L317.732 189.906Z",
    fill: "#00FE80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.38,
    cy: 66.8276,
    r: 11.5508,
    transform: "rotate(-11.7949 362.38 66.8276)",
    fill: "#E61B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.49 400.41C205.543 399.554 203.271 400.439 202.416 402.386L190.028 430.588C189.173 432.534 190.058 434.806 192.005 435.661L220.206 448.049C222.153 448.904 224.424 448.019 225.28 446.072L237.668 417.871C238.523 415.924 237.638 413.653 235.691 412.797L207.49 400.41Z",
    fill: "#E3026F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.752 247.762C423.902 247.861 422.853 249.926 423.864 251.478L441.148 278.025C442.158 279.577 444.471 279.453 445.31 277.802L459.658 249.56C460.497 247.909 459.234 245.968 457.384 246.067L425.752 247.762Z",
    fill: "#EE6D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.854 377.002C456.843 391.317 447.454 405.389 432.883 408.431C418.312 411.474 404.077 402.336 401.088 388.021C398.099 373.705 407.487 359.634 422.058 356.591C436.629 353.549 450.864 362.687 453.854 377.002ZM444.431 378.97C446.301 387.925 440.441 397.02 430.916 399.009C421.391 400.998 412.38 395.008 410.51 386.053C408.64 377.098 414.501 368.003 424.026 366.014C433.551 364.025 442.561 370.015 444.431 378.97Z",
    fill: "#0576F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.588 225.072C173.876 222.965 172.401 221.024 170.294 220.737C168.187 220.449 166.246 221.924 165.959 224.031L163.197 244.263C162.91 246.369 164.385 248.311 166.492 248.598L182.908 250.839L180.668 267.255C180.38 269.362 181.855 271.303 183.962 271.591L200.379 273.831L198.139 290.248C197.851 292.355 199.326 294.296 201.433 294.584C203.54 294.871 205.481 293.396 205.768 291.289L208.529 271.058C208.817 268.951 207.342 267.01 205.235 266.722L188.818 264.482L191.059 248.065C191.346 245.958 189.872 244.017 187.765 243.729L171.348 241.489L173.588 225.072Z",
    fill: "#AA33FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6286 394.012C64.834 394.472 64.2099 396.702 65.5052 398.026L87.6546 420.672C88.9499 421.997 91.1931 421.422 91.6923 419.638L100.23 389.133C100.729 387.349 99.1099 385.694 97.3154 386.153L66.6286 394.012Z",
    fill: "#EE6D00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBtmRight);
export default __webpack_public_path__ + "static/media/bg__btm-right.983e2aa6127fd987d77fb9995c5228c8.svg";
export { ForwardRef as ReactComponent };